import React from 'react';
import HelpCenter from '../components/HelpCenter';
import Navbar from '../components/Navbar';

const HelpPage = () => {
  return (
    
    <div className="min-h-screen bg-blanco-puro">
      <Navbar />
      <HelpCenter />
    </div>
  );
};

export default HelpPage;
